import UserMenu from '@/components/UserMenu/UserMenu'
import { APP_SET_NAVIGATION_STATUS } from '@/store/MUTATIONS-TYPES'
import AvatarEdit from '@/views/Administrativo/Usuario/Components/Avatar/AvatarEdit'
import Contact from '@/views/Contact/Contact'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { VAppBar, VBadge, VBtn, VIcon, VSpacer, VToolbarTitle, VTooltip } from 'vuetify/lib'
import ChangeLogTimeline from '@/views/ChangeLog/ChangeLogTimeline'
import { GenericDrawer, NotificationDrawer } from '@/components'
import { AttaServices, GuardianService } from '@/services'
import { DateTime } from 'luxon'
import { LOCAL_STORAGE } from '@/utils/LSUtil'

import './AppBar.scss'
import { IAppState } from '@/interfaces'
import Icons from '@/assets/icons'

@Component({})
export class AppBar extends Vue {
	@Prop({ type: Object, default: localStorage.getItem('userToken') }) userToken!: Object
	@Prop({ type: String, default: localStorage.getItem(LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN) }) lastOpenedDrawer!: string

	showChangelogBadge: boolean = false

	openContact() {
		let modal = this.$refs['contact'] as any
		modal.openModal()
	}

	async openChangeLogDrawer() {
		try {
			let response = DateTime.fromISO(await AttaServices.updateLastChangelogSeen()).toFormat('dd/MM/yyyy HH:mm:ss')
			this.lastOpenedDrawer = localStorage.getItem(LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN) || response
			localStorage.setItem(LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN, response)
			this.showChangelogBadge = false
		} catch (error) {
			console.log(error)
		}

		const drawer = this.$refs.drawer as GenericDrawer
		drawer.openDrawer()
	}

	get user() {
		const { state } = this.$store
		return state.user
	}

	get title() {
		return this.$route.meta?.title
	}

	async mounted() {
		const modalAvatarEdit = this.$refs['avatarEdit'] as AvatarEdit
		this.$root.$on('dialog:openAvatarEdit', () => modalAvatarEdit.openModal())

		let responseChangeLogs = (await GuardianService.getChangelogList(10)).result

		await this.updateUserChangelog()

		if (responseChangeLogs && responseChangeLogs.length > 0) {
			let lastTimeSeenChangelog = this.lastOpenedDrawer ? DateTime.fromFormat(this.lastOpenedDrawer, 'dd/MM/yyyy HH:mm:ss') : null
			let lastChangelogPublished = DateTime.fromISO(responseChangeLogs[0].publishedAt)

			if (lastChangelogPublished.isValid) {
				if (!lastTimeSeenChangelog || (lastTimeSeenChangelog.isValid && lastChangelogPublished > lastTimeSeenChangelog))
					this.showChangelogBadge = true
			}
		}
	}

	get notificationsUnreadCount() {
		const { state }: { state: IAppState } = this.$store
		return state.notifications.reduce((acc, notification) => acc + notification.unread, 0)
	}

	public render() {
		return (
			<div class="appbar">
				<VAppBar color={this.$vuetify.theme.dark ? '#121212' : 'white'} class="v-bar--underline" app flat outlined>
					<VToolbarTitle>{this.title}</VToolbarTitle>
					<VSpacer />

					<VBtn plain onClick={() => this.openNotificationDrawer()}>
						<VBadge class="mr-1" color="#F44336" value={this.notificationsUnreadCount} overlap dot>
							<VIcon>{Icons.Notification}</VIcon>
						</VBadge>
						Notificações
					</VBtn>

					{this.renderChangelogButton()}

					<VTooltip
						bottom
						dark
						color="primary"
						scopedSlots={{
							activator: ({ on }: { on: any }) => (
								<VBtn on={on} plain onClick={() => this.openContact()}>
									<VIcon class="mr-1">{Icons.Support}</VIcon>
									Suporte
								</VBtn>
							)
						}}
					>
						<span class="font-weight-bold">Precisa de ajuda?</span>
					</VTooltip>

					<UserMenu class="mr-10" />
					<AvatarEdit ref="avatarEdit" userId={this.user.id} />

					<Contact ref="contact" />
				</VAppBar>

				{this.user && <NotificationDrawer ref="drawerNotification" />}
				<ChangeLogTimeline ref="drawer" />
			</div>
		)
	}

	toggleNavigation() {
		const { commit } = this.$store
		commit(APP_SET_NAVIGATION_STATUS)
	}

	async updateUserChangelog() {
		if (!localStorage.getItem(LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN)) {
			let userLastChangelogSeen = await AttaServices.getLastChangelogSeen()

			if (userLastChangelogSeen)
				localStorage.setItem(
					LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN,
					DateTime.fromISO(userLastChangelogSeen).toFormat('dd/MM/yyyy hh:mm:ss')
				)
		}
	}

	get userChangelogLocal(): string {
		return localStorage.getItem(LOCAL_STORAGE.USER_LAST_CHANGELOG_SEEN)!
	}

	renderChangelogButton() {
		return (
			<div>
				{!this.showChangelogBadge && (
					<VBtn plain onClick={() => this.openChangeLogDrawer()}>
						<VIcon class="mr-1">{Icons.Changelog}</VIcon>
						Atualizações
					</VBtn>
				)}

				{this.showChangelogBadge && (
					<VBtn plain onClick={() => this.openChangeLogDrawer()}>
						<VBadge color="red" overlap dot>
							<VIcon class="mr-1">{Icons.Changelog}</VIcon>
						</VBadge>
						Atualizações
					</VBtn>
				)}
			</div>
		)
	}

	openNotificationDrawer() {
		const drawer = this.$refs.drawerNotification as GenericDrawer
		drawer.openDrawer()
	}
}

export default AppBar
